/*
 *
 * RubiconePromoCarouselPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 25-Aug-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import './RubiconePromoCarouselPopup.scss'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import { capitalizeAllString } from 'Utility/utils'
import { useNavigate } from 'react-router-dom'

const RubiconePromoCarouselPopup = (props) => {
  const navigate = useNavigate()
  const goBack = () => {
    props.actions.doHidePopup()
    navigate(props.entrypoint)
  }

  return (
    <Toggle>
      <MerchantModal
        ariaModalDescription=''
        ariaModalTitle=''
        onClose={() => goBack()}
        title={formattedMessage.titlePage(capitalizeAllString(props.infoPage.bundleCode))}
        primaryAction={() => props.actions.doHidePopup()}
        primaryButtonLabel={formattedMessage.discoverMore}
      >
        <MerchantGenericCard empty>
          <div className='rubiconePopupPromoContainer'>
            <div className='rubiconePopupCard'>
              <img src={`${process.env.CMS_URL}/services/SmartPOS-Mini-stamp.webp`} alt='alt' />
              <b>{formattedMessage.titlePos(props.infoPage?.model?.monthlyFee)}</b>
              {formattedMessage.descPos}
            </div>
            <div className='rubiconePopupCard'>
              <img src={`${process.env.CMS_URL}/services/CashBackLogo.webp`} alt='alt' />
              <b>{formattedMessage.titleCashback(props.infoPage?.cashback?.percValue?.toFixed(2).replace('.', ','))}</b>
              {formattedMessage.descCashback(capitalizeAllString(props.infoPage?.cashback?.title))}
            </div>
          </div>
        </MerchantGenericCard>
      </MerchantModal>
    </Toggle>
  )
}

RubiconePromoCarouselPopup.propTypes = {
  infoPage: PropTypes.object,
  promoCashbackConf: PropTypes.object,
  actions: PropTypes.object,
  entrypoint: PropTypes.string
}

RubiconePromoCarouselPopup.defaultProps = {
  infoPage: {},
  promoCashbackConf: {},
  actions: {},
  entrypoint: '/'
}

export default RubiconePromoCarouselPopup
